module.exports = __webpack_public_path__ + "img/cart-white.3fdb52f7.svg";